import React from 'react';
import { Shield, Target, Network, FileCheck, TrendingUp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { strategicGoals } from '../data/mock';

const iconMap = {
  Shield: Shield,
  Target: Target,
  Network: Network,
  FileCheck: FileCheck,
  TrendingUp: TrendingUp
};

export const ApproachSection = () => {
  return (
    <section id="approach" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#0f3f5d] mb-4">
            Our Strategic Approach
          </h2>
          <p className="text-xl text-gray-600">
            Five core pillars that drive exceptional results for our clients
          </p>
        </div>

        {/* Goals Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {strategicGoals.map((goal, index) => {
            const IconComponent = iconMap[goal.icon];
            
            return (
              <Card 
                key={goal.id}
                className={`group hover:shadow-2xl transition-all duration-300 ${
                  index === 4 ? 'md:col-span-2 lg:col-span-1' : ''
                }`}
              >
                <CardHeader>
                  <div className="flex items-center justify-between mb-4">
                    <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-[#508f9d] to-[#8b2e4a] flex items-center justify-center group-hover:scale-110 transition-transform">
                      <IconComponent className="w-7 h-7 text-white" />
                    </div>
                    <span className="text-4xl font-bold text-[#c2983e]/20 group-hover:text-[#c2983e]/40 transition-colors">
                      {String(goal.id).padStart(2, '0')}
                    </span>
                  </div>
                  <CardTitle className="text-xl text-[#0f3f5d] mb-2">
                    {goal.title}
                  </CardTitle>
                  <CardDescription className="text-gray-700">
                    {goal.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="bg-[#508f9d]/5 rounded-lg p-4 border-l-4 border-[#c2983e]">
                    <p className="text-sm font-semibold text-[#8b2e4a] mb-1">Focus Areas:</p>
                    <p className="text-sm text-gray-700">{goal.focus}</p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Mission & Vision Statements */}
        <div className="mt-16 max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8">
            <Card className="bg-gradient-to-br from-[#0f3f5d] to-[#508f9d] text-white border-0">
              <CardContent className="p-8 lg:p-10 text-center">
                <h3 className="text-2xl font-bold mb-4">Our Mission</h3>
                <p className="text-base leading-relaxed opacity-95">
                  Our mission is to help American and emerging-market businesses succeed across borders by delivering trusted, 
                  results-driven advisory services that reduce risk, accelerate growth, and create sustainable economic value.
                </p>
              </CardContent>
            </Card>
            
            <Card className="bg-gradient-to-br from-[#8b2e4a] to-[#c2983e] text-white border-0">
              <CardContent className="p-8 lg:p-10 text-center">
                <h3 className="text-2xl font-bold mb-4">Our Vision</h3>
                <p className="text-base leading-relaxed opacity-95">
                  To be a premier cross-border advisory firm recognized for enabling successful partnerships, investments, 
                  and market expansion between the United States and the developing world.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};
